function updateBinding(el) {
	for (let child of el.children) {
		for (let attr of el.attributes) {
			child.setAttribute(attr.name, attr.value);
		}
	}
}

export default {
	inserted(el) {
		updateBinding(el);
	},

	componentUpdated(el, binding, vnode, oldVnode) {
		updateBinding(el);
	},
};